import { AnyAction } from "redux";
import { Dispatch } from "react";
import { EventstRaw, Result } from "../../../../interfaces";
import { Create } from "../../../events";
import { Adapter } from "../../../../shared/adapter";
import { EventsAdapter } from "../../../../adapter/events-adapter";

export const FETCH_CREATE_EVENTS_REQUEST = "FETCH_EVENTS_REQUEST";
export const FETCH_CREATE_EVENTS_SUCCESS = "FETCH_EVENTS_SUCCESS";
export const FETCH_CREATE_EVENTS_FAILURE = "FETCH_EVENTS_FAILURE";

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchCreateEventsRequest = () => {
  return {
    type: FETCH_CREATE_EVENTS_REQUEST,
  };
};

const fetchCreateEventsSuccess = (data: any): ActionPagination<Result<any>> => {
  return {
    type: FETCH_CREATE_EVENTS_SUCCESS,
    payload: data,
  };
};

const fetchCreateEventsFailure = (error: any) => {
  return {
    type: FETCH_CREATE_EVENTS_FAILURE,
    payload: error,
  };
};

export const clear = () => {
  return {
    type: "CLEAR_DATA",
  };
};

export const create = (event: EventstRaw) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchCreateEventsRequest());
    try {
      const response = await Create(event);
      dispatch(
        fetchCreateEventsSuccess(
          Adapter.from(response.data).to((value) =>
            new EventsAdapter(value).adapt()
          )
        )
      );
    } catch (error: any) {
      dispatch(fetchCreateEventsFailure(error.message));
    }
  };
};
